
export const changeModel = (model, setModel) => {
    return (value, name) => {
        model[name] = value;
        setModel(model);
    }
};
